import { initTxpSettings } from 'owa-calendar-configuration';
import { trace } from 'owa-trace';

export default async function loadTxpSettings(): Promise<boolean> {
    try {
        await initTxpSettings();
        return true;
    } catch (e) {
        trace.warn(e.message || 'loadTxpSettings failed');
        return false;
    }
}
